var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-bg"},[_c('div',{staticClass:"overlay"}),_c('img',{staticClass:"background-image",attrs:{"src":require("@/assets/imagenes_planes/img2.jpg"),"alt":"Imagen de fondo"}}),_c('div',{},[_c('c_login',{staticClass:"overlay-text login"}),_c('pie',{staticClass:"fadeIn fifth",attrs:{"login":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }